$(() => {

  //require('datatables.net-dt');
  require('bootstrap-sass-datepicker');
  require('bootstrap-sass-datepicker/js/locales/bootstrap-datepicker.es');
  require('bootstrap-sass-datepicker/js/locales/bootstrap-datepicker.gl');


  window.feweb = {
    $: require('jquery'),
    jQuery: require('jquery'),
    language: function (language) {
      $.fn.datepicker.defaults.language = language;
      $('.input-group.date').datepicker('remove');
      $('.input-group.date').datepicker({
        format: "dd/mm/yyyy",
        orientation: "top auto",
        todayBtn: true,
        weekStart: 1,
        todayHighlight: true,
        autoclose: true
      });
    },
    setDate:function (elem, day, month, year) {
      $(elem).datepicker("update", new Date(year, month, day));
      onDayChange();
    },
    getDate:function (elem) {
      var day = $(elem).datepicker("getDate");
      var dd = day.getDate();
      var mm = day.getMonth()+1; //January is 0!

      var yyyy = day.getFullYear();
      if(dd<10){
        dd='0'+dd;
      }
      if(mm<10){
        mm='0'+mm;
      }
      day = dd+'/'+mm+'/'+yyyy;
      return day;
    }
  };

  //Initialize DataTables
  /*$('.table').DataTable({
    paging: false,
    info: false,
    filter: false,
    responsive: false,
    autoWidth: false
  });*/

  //Initialize DatePicker
  $.fn.datepicker.defaults.language = 'gl';
  $('.input-group.date').datepicker({
    format: "dd/mm/yyyy",
    orientation: "top auto",
    todayBtn: true,
    weekStart: 1,
    todayHighlight: true,
    autoclose: true
  });

  //Calendar Control
  $;
  $('.input-group.date.in-date-from').on('changeDate', function () {
    onDayChange();
  });
  function onDayChange(){
    if($('.input-group.date.in-date-from') && $('.input-group.date.in-date-from').val().length !== ''){
      var from = $('.input-group.date.in-date-from').find('input').val().split("/");
      var in_date_form_date = new Date(from[2], from[1] - 1, from[0]);
      in_date_form_date.setDate(in_date_form_date.getDate()+1);

      var from = $('.input-group.date.in-date-to').find('input').val().split("/");
      var in_date_to_date = new Date(from[2], from[1] - 1, from[0]);
      if(in_date_form_date > in_date_to_date){
        $('.input-group.date.in-date-to').datepicker('update', '');
      }

      $('.input-group.date.in-date-to').datepicker('remove');
      $('.input-group.date.in-date-to').datepicker({
        format: "dd/mm/yyyy",
        orientation: "top auto",
        todayBtn: true,
        startDate: in_date_form_date,
        weekStart: 1,
        todayHighlight: true,
        autoclose: true
      });
    }else{
      $('.input-group.date.in-date-to').datepicker('remove');
      $('.input-group.date.in-date-to').datepicker({
        format: "dd/mm/yyyy",
        orientation: "top auto",
        todayBtn: true,
        weekStart: 1,
        todayHighlight: true,
        autoclose: true
      });
    }
  }

  //In "Os meus datos" Switch between "Datos personales" and "Datos profesionales"
  $('#user-data').find('a[data-target$="-data"]').on('click', function () {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    $('#user-data').find($(this).data('target')).addClass('active');
    $('#user-data').find($(this).siblings().data('target')).removeClass('active');
  });

  //Make link rows
  $(".clickable-row td").click(function () {
    var data_ref = $(this).parent().data("href");
    if (!$(this).hasClass('table-row-opts')) {
      window.location = data_ref;
    }
  });

  //Initialize table-tooltip
  $('.table-tooltip').tableTooltip();

  //Initialize radio_control
  $('.radio-control').radioControl();

  //Initialize tableToCardsCarousel
  $(window).tableToCardsCarousel({
    max_width: '992',
  });
  //Initialize tableToCards
  $(window).tableToCards({
    max_width: '992',
  });
  //Initialize Transpose Tables
  // $(window).transpose({
  //   max_width: '786',
  // });

  // Initialize side-menu
  $('#side-menu').sideMenu();


  // Initialize default selectizes
  $('select.auto-selectize').each(function () {
    const $this = $(this);
    $this.selectize({
      allowEmptyOption: true,
      searchField: false,
    });
  });

  $('.selectize-input > input').prop('readonly', true);

  $('.selectize-input > input').each(function( ) {
    var keydown_0 = $._data( this, "events" )['keydown'][0]['handler'];
    var keydown_1 = $._data( this, "events" )['keydown'][1]['handler'];
    $(this).off("keydown");

    $(this).on("keydown",function (e, options) {
      if(e.keyCode !== 13 && e.keyCode !== 37 && e.keyCode !== 38 && e.keyCode !== 39 && e.keyCode !== 40){
        e.stopPropagation();
        return false;
      } else {
        keydown_0(e, options);
        keydown_1(e, options);
      }
    });

    var keyup_0 = $._data( this, "events" )['keyup'][0]['handler'];
    var keyup_1 = $._data( this, "events" )['keyup'][1]['handler'];
    $(this).off("keyup");

    $(this).on("keyup",function (e, options) {
      if(e.keyCode !== 13 && e.keyCode !== 37 && e.keyCode !== 38 && e.keyCode !== 39 && e.keyCode !== 40){
        e.stopPropagation();
        return false;
      } else {
        keyup_0(e, options);
        keyup_1(e, options);
      }
    });
  });

  //Initialize selectize-tooltip
  $('.selectize-input, .selectize-dropdown-content').selectizeTooltip();


});




// WEBPACK FOOTER //
// ./source/assets/javascripts/main.js